// import isAuthenticatedGuard from '@/modules/auth/composables/auth-guard';
import { isAuthenticatedGuard } from '../composables/auth-guard';
export default {
   path: '/multicotizador',
   name: 'auth',
   children: [
      {
         path: 'login',
         name: 'login',
         component: () =>
            import(
               /* webpackChunkName: "Login" */ '@/modules/auth/views/LoginView.vue'
            ),
         meta: { requiresLayout: false },
      },
      {
         path: 'menu',
         name: 'menu',
         component: () =>
            import(
               /* webpackChunkName: "Login" */ '@/modules/auth/views/MenuView.vue'
            ),
         meta: { requiresLayout: true },
         beforeEnter: [isAuthenticatedGuard],
      },
      {
         path: 'recover-password',
         name: 'recover-password',
         component: () =>
            import(
               /* webpackChunkName: "ResetPassword" */ '@/modules/auth/views/ResetPasswordView.vue'
            ),
         meta: { requiresLayout: false },
      },
   ],
};
